import DemoCTA from '../DemoCTA.jsx';
import { isPlaceholder } from '../../data/products.js';
import { STAGES } from '../stages/index.js';
import TheoLogo from '../TheoLogo.jsx';
import OpenChartsLogo from '../OpenChartsLogo.jsx';

/* Pick the right brand mark for the deep-dive hero name. Products
   without a custom mark fall back to the product name. */
function HeroMark({ product, height }) {
  if (product.id === 'theo') return <TheoLogo height={height} />;
  if (product.id === 'charts') return <OpenChartsLogo height={height} />;
  return product.name;
}

/* <ProductHero />
   ----------------------------------------------------------
   Top of each product deep-dive card. Holds the eyebrow,
   product name, headline / value prop, lede paragraph, the
   "Book walkthrough demo" CTA, the optional presentation link,
   and the matching Stage* visual to the right. */
export default function ProductHero({ product }) {
  const Stage = STAGES[product.id];
  const showPresentation = !isPlaceholder(product.presentationLink);

  return (
    <div className="product-deep-dive__hero">
      <div>
        <div className="product-deep-dive__eyebrow">
          <span className="pip" />
          {product.eyebrow}
        </div>
        <h3 className="product-deep-dive__name">
          <HeroMark product={product} height={88} />
        </h3>
        <p className="product-deep-dive__valueprop">{product.valueProp}</p>
        <p className="product-deep-dive__lede">{product.headline}</p>
        <div className="product-deep-dive__hero-actions">
          <DemoCTA variant="primary" source={product.id} label={product.ctaLabel} />
          {showPresentation && (
            <a
              className="presentation-link"
              href={product.presentationLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              View product
              <svg className="presentation-link__icon" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path
                  d="M3 11L11 3M11 3H5M11 3V9"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          )}
        </div>
      </div>
      <div className="product-deep-dive__visual">
        {Stage && <Stage />}
      </div>
    </div>
  );
}
